/* unplugin-vue-components disabled */import script from "./showAuthList.vue?vue&type=script&setup=true&lang=js"
export * from "./showAuthList.vue?vue&type=script&setup=true&lang=js"

import "./showAuthList.vue?vue&type=style&index=0&id=3737b708&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户武汉科技-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3737b708"]])

export default __exports__